import { formatDateTime } from "../../helpers/dateFormat";

export const getTransDtlsSoapV1 = (xml) => {
  try {
      const errMsgNode = xml.getElementsByTagName("errMsg")[0];
      if (errMsgNode) {
        return { error: errMsgNode.textContent };
      }

    const obtainedCvr = xml.getElementsByTagName("obtainedCvr")[0]?.textContent || "";

    const coverageListItems = obtainedCvr.match(/[^,(]+(?:\([^)]*\))?[^,]*/g).map(item => `<li>${item.trim()}</li>`);

    const coverageList = `<ul>${coverageListItems.join("")}</ul>`;

      return {
        carName: xml.getElementsByTagName("make")[0]?.textContent || "N/A",
        modelName: xml.getElementsByTagName("model")[0]?.textContent || "N/A",
        plateNumber: xml.getElementsByTagName("vehRegNo")[0]?.textContent || "N/A",
        plateCode: xml.getElementsByTagName("vehRegLOC")[0]?.textContent || "N/A",
        modelYear: xml.getElementsByTagName("modelYear")[0]?.textContent || "N/A",
        chassisNo: xml.getElementsByTagName("chasisNo")[0]?.textContent || "N/A",
        bodyType: xml.getElementsByTagName("vehBody")[0]?.textContent || "N/A",
        usageType: xml.getElementsByTagName("usage")[0]?.textContent || "N/A",
        vehicleValue: xml.getElementsByTagName("vehValue")[0]?.textContent || "N/A",
        insuredName: xml.getElementsByTagName("insureFullName")[0]?.textContent || "N/A",
        civilId: xml.getElementsByTagName("insuredLicNo")[0]?.textContent || "N/A",
        age: xml.getElementsByTagName("insuredAge")[0]?.textContent || "N/A",
        quoteNo: xml.getElementsByTagName("renewalQuoteNo")[0]?.textContent || "N/A",
        coverFromDate: formatDateTime(xml.getElementsByTagName("effectiveDt")[0]?.textContent || "N/A"),
        coverToDate: formatDateTime(xml.getElementsByTagName("expirationDt")[0]?.textContent || "N/A"),
        product: xml.getElementsByTagName("prodId")[0]?.textContent || "N/A",
        plan:xml.getElementsByTagName("planSelection")[0]?.textContent || "N/A",
        premiumAmt:xml.getElementsByTagName("premiumAmt")[0]?.textContent || "N/A",
        coverage:xml.getElementsByTagName("obtainedCvr")[0]?.textContent || "N/A",
        quoteStatus: xml.getElementsByTagName("quoteStatus")[0]?.textContent || "N/A",
        mobileNo: xml.getElementsByTagName("insuredMobileNo")[0]?.textContent || "N/A",
        eMailId: xml.getElementsByTagName("insuredEmailId")[0]?.textContent || "N/A",
        whatsappNo: "",
        coverageList: coverageList,
        isTransConfirmPlan :true
      };
    } catch (error) {
      console.error("Error extracting data:", error);
      return { error: "Unexpected response format" };
    }
  };